import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VTooltip,{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var attrs = ref.attrs;
var on = ref.on;
return [_c(VBtn,_vm._g(_vm._b({staticClass:"ml-2",attrs:{"icon":"","small":""},on:{"click":function (_) { return _vm.openQuickInterviewDiff(); }}},'v-btn',attrs,false),on),[_c(VIcon,{attrs:{"small":""}},[_vm._v(" mdi-eye-outline ")])],1)]}}])},[_vm._v(" View Changes ")])}
var staticRenderFns = []

export { render, staticRenderFns }